<template>
    <div>
        <vs-row class="my-2" style="min-height:120px;">
                <vs-col vs-lg="4" vs-sm="12">
                     <vs-card>
                    <ul class="statistic text-center">
                        <li>
                            <h3>{{stat.AttendeesTotal | numFormat('0,0')}}</h3>
                            <div>Total Attendees</div>
                        </li>
                         <li>
                            <h3>{{stat.Attendees | numFormat('0,0')}}</h3>
                            <div>Confirmed</div>
                        </li>
                         <li>
                            <h3>{{stat.AttendeesPending | numFormat('0,0')}}</h3>
                            <div>Pending</div>
                        </li>
                         <li>
                            <h3>{{stat.CheckedIn | numFormat('0,0')}}</h3>
                            <div>Checked-in</div>
                        </li>
                    </ul>
                     </vs-card>
                </vs-col>
                <vs-col vs-lg="7" vs-sm="12" vs-offset="1">
                    <vs-card>
                        <div style="100%;">
                            <label>Checked-in {{stat.CheckedinPercent}}%</label>
                            <vs-progress :height="12" :percent="parseFloat(stat.CheckedinPercent)" color="success">Checked-in</vs-progress>
                        </div>
                    </vs-card>
                </vs-col>
        </vs-row>
        <div>
            <vs-card>
                  <b-table
                    ref="table"
                    style="min-height: 600px;"
                    striped
                    hover
                    fixed
                    responsive
                    show-empty
                    sort-icon-left
                    :selectable="true"
                    :select-mode="`multi`"
                    :busy.sync="isBusy"
                    :items="dataProvider"
                    :fields="columns"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                >
                    <template v-slot:table-busy>
                    <div class="text-center text-danger my-2" style="height:600px;">
                        <b-spinner class="align-middle"></b-spinner>
                        <div class="mt-3">
                        <strong>Loading...</strong>
                        </div>
                    </div>
                    </template>
                </b-table>
            </vs-card>
        </div>
    </div>
</template>
<script>
import Service from "@/services";
export default {
  components: {},
  data: () => ({
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Name", key: "name", sortable: true },
      { label: "Ticket", key: "ticket", sortable: true },
      { label: "Role", key: "role", sortable: true },
      { label: "Type", key: "type", sortable: true },
      { label: "Consent", key: "consent", sortable: true },
      { label: "At", key: "at", sortable: true },
    ],
    stat:{
        Attendees :0,
        AttendeesPending: 0,
        AttendeesTotal: 0,
        CheckedIn: 0,
        CheckedinPercent :0,
        SelfRegistrationOnsite :0,
        SelfRegistrationOnsitePending :0
    }
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        return Service.Report.checkinTickets(params)
          .then((res) => {
            this.data = res.data.rows.map((item) => {
             return{
                 name : item.firstName+' '+item.lastName,
                 ticket: item.ticket,
                 role: item.type,
                 consent : '',
                 type : item.checkin_oper,
                 at : item.checkin_date
             }
            });
            this.checkinStats()
            callback(this.data);
          })
          .catch((error) => {
            this.checkinStats()
            callback([]);
          });
          
      }, 500);
    },
    checkinStats(){
        let data = {
          e: this.$route.query.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        Service.Report.checkinStats(params).then(res=>{
            this.stat = res.data.stats
        })
    }
  },
};
</script>